import { Loading, notify } from "@general-backoffice/core";
import Header from "@general-backoffice/core/lib/pages/auth/components/Header";
import { authEndpoints } from "@investhinks/api-client";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import handleError from "../../../components/utils/handleError";
import type { PersistedRootState } from "../../../redux/reducers/session/state";
import refreshMe from "../../../utils/refreshMe";

const ConfirmEmail: React.FC = () => {
  const { t } = useTranslation("auth", { keyPrefix: "confirmEmail" });
  const [searchParams] = useSearchParams();
  const [confirmed, setConfirmed] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const dispatch: (action: { type: string; payload?: unknown }) => void = useDispatch();
  const state = useSelector((state: PersistedRootState) => state);

  const token = searchParams.get("code");

  // refreshMe changes the session state; keep it out of the effect deps so a
  // successful confirm doesn't re-fire with the now-authenticated JWT (403).
  const stateRef = useRef(state);
  stateRef.current = state;
  const confirmedTokenRef = useRef<string | null>(null);

  useEffect(() => {
    if (!token || confirmedTokenRef.current === token) return;
    confirmedTokenRef.current = token;
    setLoading(true);
    setConfirmed(false);
    authEndpoints
      .confirmEmail(token)
      .then(({ data }) => {
        notify.success(data?.message || "Email confirmed");
        refreshMe({ state: stateRef.current, dispatch });
        setConfirmed(true);
      })
      .catch((e) => handleError(e.message, false))
      .finally(() => setLoading(false));
  }, [token, dispatch]);

  // if(!token) return <Navigate to="/" replace />
  return (
    <React.Fragment>
      <Header title={t("title")} />
      <Container className="mt--7 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              <CardBody className="px-lg-5 py-lg-5 text-center">
                {isLoading ? (
                  <Loading.BouncingDots />
                ) : (
                  <div>
                    <div className="mb-4">{confirmed ? t("confirmationSuccess") : t("confirmationFailure")}</div>

                    <Link to="/">
                      <Button color="primary">{t("goBack")}</Button>
                    </Link>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ConfirmEmail;
